export const ADMISSION_DENTISTRY = 'dentistry'
export const ADMISSION_OPTOMETRY = 'optometry'

export const ADMISSION_TYPES = {
  [ADMISSION_DENTISTRY]: 'Dentistry',
  [ADMISSION_OPTOMETRY]: 'Optometry',
}
